import { render } from "./LogisticsFilterForm.vue?vue&type=template&id=c45296f0&scoped=true"
import script from "./LogisticsFilterForm.vue?vue&type=script&lang=js"
export * from "./LogisticsFilterForm.vue?vue&type=script&lang=js"

import "./LogisticsFilterForm.vue?vue&type=style&index=0&id=c45296f0&lang=css&scoped=true"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45296f0"]])

export default __exports__